<template>
  <div>
    <portal to="contact-merge-header">
      <h3 class="text-lg font-medium text-center">Select Duplicate Contacts</h3>
      <p class="text-sm mt-2 text-center font-normal text-gray-600">
        To merge duplicates select up to 3 contacts. Then click Next and choose the fields to keep.
      </p>
    </portal>

    <ContactList :account-id="accountId" />

    <portal to="contact-merge-next">
      <template #default="{ nextStep }">
        <BaseButton
          :disabled="totalSelectedContacts < 2 || totalSelectedContacts > 3"
          primary
          @click="nextStep"
        >
          Next
        </BaseButton>
      </template>
    </portal>
  </div>
</template>

<script>
import ContactList from './contact-list.vue';

export default {
  components: {
    ContactList,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
  computed: {
    totalSelectedContacts() {
      return this.$store.getters[`${this.accountId}:contactMerge/selectedContactIds`].length;
    },
  },
};
</script>
